export const btnStyleClassMapping = {
  primary: 'custom-primary-button-class',
  secondary: 'custom-secondary-button-class',
  roundedSecondary: 'custom-rounded-secondary-button-class',
  float: 'custom-float-button-class',
  other: ''
};

export const iconPosition = {
  RIGHT: 'right',
  LEFT: 'left',
};
